import React, { Component } from "react";

class Beta extends Component {
  render() {
    const style = {
      height: "35px",
      fontSize: "1em",
      fontFamily: "Rubik, sans-serif",
      color: "#fff",
      backgroundColor: "#293352",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };

    const styleLink = {
      height: "35px",
      fontSize: "1em",
      fontFamily: "Rubik, sans-serif",
      color: "#fff",
      backgroundColor: "#293352",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "underline",
      paddingLeft: "5px",
      paddingRight: "5px"
    };
    return (
      <div style={style}>
        You are viewing the BETA version of the Tikki website.
        <a style={styleLink} href="mailto:hello@tikki.org">
          Give us your feedback
        </a>
        to help improve it.
      </div>
    );
  }
}

export default Beta;



// WEBPACK FOOTER //
// ./src/components/Beta.js